/**
 * @generated SignedSource<<ceb81b46bd0e90e9316cd90119a6a830>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MultiUploadInputObject = {
  uploads: ReadonlyArray<UploadInputObject>;
};
export type UploadInputObject = {
  id: string;
  metadata: UploadMetadataInputObject;
  storage: string;
};
export type UploadMetadataInputObject = {
  filename: string;
  mimeType: string;
  size: number;
};
export type walletUploader_StartMutation$variables = {
  input: MultiUploadInputObject;
  slug: string;
};
export type walletUploader_StartMutation$data = {
  readonly walletUploadStart: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly job: {
      readonly phase: string | null | undefined;
      readonly status: string;
    } | null | undefined;
  } | null | undefined;
};
export type walletUploader_StartMutation = {
  response: walletUploader_StartMutation$data;
  variables: walletUploader_StartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "multiUploadInput",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "job",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "walletUploader_StartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WalletUploadStartMutationPayload",
        "kind": "LinkedField",
        "name": "walletUploadStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "walletUploader_StartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WalletUploadStartMutationPayload",
        "kind": "LinkedField",
        "name": "walletUploadStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0484d48e3e028070f1cffe06f8a20013",
    "id": null,
    "metadata": {},
    "name": "walletUploader_StartMutation",
    "operationKind": "mutation",
    "text": "mutation walletUploader_StartMutation(\n  $slug: String!\n  $input: MultiUploadInputObject!\n) {\n  walletUploadStart(slug: $slug, multiUploadInput: $input) {\n    job {\n      status\n      phase\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a70b3b04a4b29436ca4e69ce1ab560c9";

export default node;
